import Page from '../../components/layouts/page'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '@bitcine/cinesend-theme/dist'
import useStore from '../../hooks/use_store'
import { useState } from 'react'
import useAuth from '../../hooks/use_auth'
import { modelTypes } from '../../constants/model_types'
import CreateForm from '../metadata/create_form'
import GroupsPoolsTable from '../../components/groups_pools_table'
import { useQuery } from '@tanstack/react-query'

const GroupsPools = () => {
  const params = useParams()
  const navigate = useNavigate()
  const { createModel } = useStore()
  const [showCreateModal, setShowCreateModal] = useState(false)
  const queryKey = `/categories?cycleID=${params.cycleID}`
  const { canEditModel: canEditCategory } = useAuth(modelTypes.Category, { is_root: false })
  const { data: cycle } = useQuery(['cycles/', params.cycleID])

  return (
    <Page
      title={'Groups & Pools'}
      buttons={[
        <div key={'groups-pools-buttons'} className='space-x-2 flex items-center'>
          {canEditCategory && (
            <Button icon='list' disabled={!!cycle?.is_locked} onClick={() => setShowCreateModal('warning-slates')}>
              Create Warning Slate Group
            </Button>
          )}
          {canEditCategory && (
            <Button icon='list' disabled={!!cycle?.is_locked} onClick={() => setShowCreateModal('ad-pools')}>
              Create Ad Pool
            </Button>
          )}
        </div>,
      ]}
    >
      <GroupsPoolsTable queryKey={queryKey} />
      {!!showCreateModal && (
        <CreateForm
          isOpen={!!showCreateModal}
          onClose={() => setShowCreateModal(false)}
          cycleID={params.cycleID}
          createModel={createModel}
          categoryType={showCreateModal}
          onSuccess={(res) =>
            navigate(
              `/airlines/${params.airlineID}/cycles/${params.cycleID}/ads/groups-pools/${res.data.category.id}/details`
            )
          }
        />
      )}
    </Page>
  )
}

export default GroupsPools
